export * from './login.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/login/index.ts